/**
 * Custom Element: pack-bundle
 */

class PackBundle extends HTMLElement {
  constructor() {
    super();
    this.abortController = null;
  }

  connectedCallback() {
    this.sectionId = this.dataset.sectionId;
    this.packRadios = this.querySelectorAll("[data-variant-bundle]");
    this.priceContainer = document.getElementById(`price-${this.sectionId}`);
    this.productForm = document.getElementById(
      `product-form-${this.sectionId}`,
    );

    if (this.packRadios.length === 0) return;

    this.abortController = new AbortController();
    const { signal } = this.abortController;

    this.packRadios.forEach((radio) => {
      radio.addEventListener("change", () => this.onVariantChange(radio), {
        signal,
      });

      const optionButton = radio
        .closest("label")
        ?.querySelector('button[type="button"]');

      if (optionButton) {
        optionButton.addEventListener(
          "click",
          () => {
            if (radio.disabled) return;

            radio.checked = true;
            radio.dispatchEvent(new Event("change", { bubbles: true }));
          },
          { signal },
        );
      }
    });

    // Initial price update
    const selectedRadio = this.querySelector("[data-variant-bundle]:checked");
    if (selectedRadio) {
      this.onVariantChange(selectedRadio);
    }
  }

  disconnectedCallback() {
    if (this.abortController) {
      this.abortController.abort();
    }
  }

  onVariantChange(radio) {
    if (!radio.checked) return;

    this.packRadios.forEach((packRadio) => {
      const optionButton = packRadio
        .closest("label")
        ?.querySelector('button[type="button"]');

      optionButton?.setAttribute(
        "aria-current",
        packRadio === radio ? "true" : "false",
      );
    });

    const { value: variantId, dataset } = radio;
    const { variantTitle, price, comparePrice } = dataset;

    if (this.productForm) {
      const idInput = this.productForm.querySelector(
        'input[name="id"]:not([type="radio"])',
      );
      if (idInput) idInput.value = variantId;
    }

    this.updateDisplayPrices(price, comparePrice);

    if (window.publish && window.PUB_SUB_EVENTS) {
      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event: { target: radio },
          target: radio,
          selectedOptionValues: [variantTitle],
        },
      });
    }
  }

  updateDisplayPrices(price, comparePrice) {
    if (!this.priceContainer) return;

    if (price) {
      const priceEls = this.priceContainer.querySelectorAll("[data-price]");
      priceEls.forEach((el) => {
        if (comparePrice && comparePrice !== "") {
          el.innerHTML = `<span class="v:discounted-price">${comparePrice}</span> <span>${price}</span>`;
        } else {
          el.textContent = price;
        }
      });
    }

    const comparePriceEls = this.priceContainer.querySelectorAll(
      "[data-compare-price]",
    );
    comparePriceEls.forEach((el) => {
      if (comparePrice && comparePrice !== "") {
        el.textContent = comparePrice;

        const parent = el.closest("span") || el.parentElement;
        if (parent) parent.classList.remove("hidden");
      } else {
        const parent = el.closest("span") || el.parentElement;
        if (parent) parent.classList.add("hidden");
      }
    });
  }
}

if (!customElements.get("pack-bundle")) {
  customElements.define("pack-bundle", PackBundle);
}
